// Implementations taken from https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore
export const uniq = (arr) => Array.from(new Set(arr));
export const uniqWith = (arr, fn) => arr.filter((element, index) => arr.findIndex((step) => fn(element, step)) === index);
export const isString = str => str != null && typeof str.valueOf() === 'string';
